import React from 'react'

const About = () => {
  return (
    <section className="about-section ">
      <div className="container banner-div-top">
        <div className="row">
          <div className="col-lg-6">
            <div className="about-content">
              <div className="about-border">
                <h1>Passion</h1>
                <img src="./assets/image/about-icon-1.png" alt="about-section" />
                <p>Nous sommes des passionnés qui désirent sincèrement changer le monde un projet à la fois. Les chiffres, les mathématiques, l'immobilier mais surtout le bonheur des gens derrière chaque projet entrepreneurial, ce sont toutes les choses qui nous passionnent et nous poussent à nous investir sans réserve dans la réalisation de vos rêves les plus fous.</p>
              </div>
            </div>
            <div className="about-content about-inner">
              <div className="about-border">
                <h1>Engagement </h1>
                <img src="./assets/image/about-icon-3.png" alt="about-section" />
                <p>Votre succès, votre réussite ainsi que la réalisation de vos rêves les plus chers sont notre priorité. Nous sommes pleinement engagés dans le succès de votre plan de vie entrepreneurial. Conscients de la confiance que vous nous accordez avec ce qui est précieux et cher à votre cœur, nous allons au fond de chaque mandat pour livrer les résultats dont vous avez besoin.</p>
              </div>
            </div>
            <div className="about-content about-inner">
              <div className="about-border">
                <h1>Empathie </h1>
                <img src="./assets/image/about-icon-2.png" alt="about-section" />
                <p>Nous partageons les mêmes rêves et ambitions que nos clients. Nous comprenons très bien la réalité des entrepreneurs en immobilier et cela nous permet de connecter avec nos clients et de nous investir personnellement dans leur projet de vie. La réalisation de vos objectifs est tout autant importante pour nous qu'elle peut l'être pour vous.</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-bottom">
              <div className="about-content">
                <div className="about-border">
                  <h1>Excellence </h1>
                  <img src="./assets/image/about-icon-2.png" alt="about-section" />
                  <p>Notre expertise est ancrée profondément dans notre volonté de continuellement nous améliorer et développer de nouvelles connaissances pour mieux vous servir. Nous avons étudié pendant des années afin de faire partie de l'élite des professionnels de la finance. Mais nous avons également complété notre coffre à outils avec de l'expérience concrète, forgée sur le terrain de projets immobiliers complexes et porteurs qui ont affiné notre approche.</p>
                </div>
              </div>
              <div className="about-content">
                <div className="about-border">
                  <h1>Intégrité </h1>
                  <img src="./assets/image/about-icon-1.png" alt="about-section" />
                  <p>Face aux multitudes de situations délicates auxquelles les investisseurs immobiliers sont confrontés, vous pourrez toujours compter sur notre transparence, notre soutien indéfectible et nous accorder votre confiance la plus totale. Notre intégrité est un rempart sur lequel toutes nos relations long terme sont bâties.</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="h-25vh"></div>
    </section>
  )
}

export default About
